import { render, staticRenderFns } from "./SelectPersonType.vue?vue&type=template&id=0f01d35a&scoped=true&"
import script from "./SelectPersonType.vue?vue&type=script&lang=js&"
export * from "./SelectPersonType.vue?vue&type=script&lang=js&"
import style0 from "./SelectPersonType.vue?vue&type=style&index=0&id=0f01d35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01d35a",
  null
  
)

export default component.exports